var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-modal',{staticClass:"preview-image",attrs:{"width":_vm.width,"visible":_vm.previewVisible,"footer":null,"closable":false},on:{"cancel":function($event){_vm.previewVisible = false}}},[_c('img',{staticClass:"img",attrs:{"src":_vm.imageSrc}})])
}
var staticRenderFns = []

export { render, staticRenderFns }